import stringByKeyByLocale from "content/l10n/l10n-complete"

class L10n {
  constructor(options) {
    this._locale = options.locale
  }

  // this is for using handlebars style template within l10n strings
  // templateMap should be a object containing key value pairs like:
  // `{name:'Arun'}`, then instances of `{{name}}` in the string will
  // be replaced with `Arun`. We use a regexp so that every instance
  // of the key will be replaced, not just the first instance.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  replaceAllKeysWithValues(templateString, templateMap) {
    Object.keys(templateMap).forEach(
      (key) => (templateString = templateString.replace(new RegExp(`{{${key}}}`, "g"), templateMap[key]))
    )
    return templateString
  }

  localize(key, templateMap) {
    if (Array.isArray(key)) {
      key = key[0]
    }

    let outputString = stringByKeyByLocale[this._locale][key] ?? key

    if (templateMap) {
      outputString = this.replaceAllKeysWithValues(outputString, templateMap)
    }

    return outputString
  }

  getBoundLocalize() {
    const self = this
    return function () {
      return self.localize.apply(self, arguments)
    }
  }
}

export default L10n
